export const SpaceVertical = ({ size }) => {
  return <div style={{ marginTop: size ? size : 10 }}></div>;
};

export const SpaceHorizontal = ({ size }) => {
  return <div style={{ marginRight: size ? size : 10 }}></div>;
};
